import React, { useState } from 'react';
import { Col, Row, Form, Button, InputGroup } from 'react-bootstrap';
import { Typewriter } from 'react-simple-typewriter';
import '../../styles/login.scss';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { resetPassword } from '../../redux/slices/authSlice';
import Logo from '../../assets/logo7.png';

const ResetPassword = () => {
  const { uidb64, token } = useParams(); // Extract URL parameters
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [loading] = useState(false);
  const dispatch = useDispatch();
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (password1 !== password2) {
  //     setMessage('Passwords do not match.');
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     serverUrl.post(
  //       `users/reset/${uidb64}/${token}/`,
  //       { new_password1: password1, new_password2: password2 }
  //     );
  //     setMessage('Password reset successful! Redirecting to login...');
  //     setTimeout(() => navigate('/login'), 2000);
  //   } catch (error) {
  //     setMessage(
  //       error.response?.data?.detail ||
  //         'Invalid or expired link. Please request a new password reset.'
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (password1 !== password2) {
      toast.error('Passwords do not match.');
      return;
    }

    const data = {
      uidb64,
      token,
      new_password1: password1,
      new_password2: password2,
    };

    dispatch(resetPassword(data))
      .unwrap()
      .then(() => {
        toast.success('Password reset successful! Please login.');
        setTimeout(() => navigate('/login'), 2000);
      })
      .catch((err) => {
        toast.error(err?.detail || 'Password reset failed.');
      });
  };

  return (
    <Row className="login-row">
      {/* Left Side */}
      <Col md={6} className="login-left">
        <div className="overlay"></div>
        <div className="login-left-content">
          <img className="logo" src={Logo} alt="logo" />
          <h2 className="typing-text">
            <Typewriter
              words={[
                'Reset your password securely.',
                'Your creativity deserves protection.',
                'We’re here to help you get back in.',
              ]}
              loop
              cursor
              cursorStyle="_"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1500}
            />
          </h2>
        </div>
      </Col>

      {/* Right Side */}
      <Col md={6} className="login-right">
        <div className="login-form-container">
          <h2>Reset Password</h2>
          <Form onSubmit={handleResetPassword}>
            {/* New Password */}
            <Form.Group className="mb-4" controlId="newPassword1">
              <Form.Label>New Password</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter new password"
                  className="form-input"
                  value={password1}
                  onChange={(e) => setPassword1(e.target.value)}
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                </Button>
              </InputGroup>
            </Form.Group>

            {/* Confirm Password */}
            <Form.Group className="mb-4" controlId="newPassword2">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm new password"
                className="form-input"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
              />
            </Form.Group>

            <Button
              type="submit"
              className="w-100 login-btn mb-3"
              disabled={loading}
            >
              {loading ? 'Resetting...' : 'Reset Password'}
            </Button>
          </Form>
        </div>
      </Col>
    </Row>
  );
};

export default ResetPassword;
